import {isServerComponent} from "../stores/InterfaceStore";
import {createServerOnlyContext, readContext, ServerOnlyContext} from 'react-server-only-context'
import React from "react";

export function createUniversalContext<T>(defaultValue: T): ServerOnlyContext<T> | React.Context<T> {
    if (isServerComponent) {
        return createServerOnlyContext(defaultValue);
    } else {
        return React.createContext(defaultValue);
    }
}

export function useUniversalContext<T>(Context: ServerOnlyContext<T> | React.Context<T>) {
    if (isServerComponent) {
        return readContext(Context as ServerOnlyContext<T>);
    } else {
        return React.use(Context as React.Context<T>);
    }
}